import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './button.scss';

const typeToComponent = {
  link: Link,
  button: 'button'
};

export const CustomButton = (props) => {
  const {
    title = '',
    onClick = () => {},
    className = '',
    variant = 'primary',
    component = 'button',
    icon = null,
    iconPosition = 'left',

    ...rest
  } = props;

  const componentValue = component || 'button';

  const Component = typeToComponent[componentValue];

  const buttonStyles = classNames('button', {
    'button--primary': variant === 'primary',
    [className]: className
  });

  const renderTitle = useCallback(() => {
    const Icon = icon;

    return (
      <>
        {icon && iconPosition === 'left' ? <Icon style={{ marginRight: 8 }} /> : null}
        {title}
        {icon && iconPosition === 'right' ? <Icon style={{ marginLeft: 8 }} /> : null}
      </>
    );
  }, [icon, iconPosition, title]);

  return (
    <Component onClick={onClick} className={buttonStyles} {...rest}>
      {renderTitle()}
    </Component>
  );
};

CustomButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary']),
  component: PropTypes.oneOf(['link', 'button']),
  icon: PropTypes.func,
  iconPosition: PropTypes.oneOf(['left', 'right'])
};
